import { Channel as ChannelContainer } from 'Containers/Channel';
import { inject, observer } from 'mobx-react';
import React from 'react';
import { SidebarProvider } from '~/lib/ui/sidebar';
import ContextContentLoadingPanel from '../../components/ContextContentLoadingPanel';
import { ContentArea } from '../../components/shared/ContentArea';
import {
  STORE_CONTACT,
  STORE_CONVERSATION,
  STORE_NOTIFICATION,
  STORE_PARTICIPANT,
  STORE_PERSON,
  STORE_PHONE_CALL,
  STORE_PUSHER,
  STORE_UI,
} from '../../constants/stores';
import { ContextPanelProps } from '../ContextPanel/interfaces';
import ConversationsPanel from '../ConversationsPanel';

class ContextContentLoadingContainer extends React.Component<ContextPanelProps> {
  render() {
    const { ui } = this.props;
    return (
      <div className="relative flex h-full min-w-0 flex-1">
        <SidebarProvider className="flex min-w-0 flex-1 h-full">
          <ConversationsPanel />
          <ChannelContainer />
          <div className="min-w-0 flex-1">
            <ContentArea>
              <ContextContentLoadingPanel {...{ ui }} />
            </ContentArea>
          </div>
        </SidebarProvider>
      </div>
    );
  }
}
export default inject(
  STORE_PERSON,
  STORE_CONVERSATION,
  STORE_UI,
  STORE_PARTICIPANT,
  STORE_CONTACT,
  STORE_PHONE_CALL,
  STORE_NOTIFICATION,
  STORE_PUSHER
)(observer(ContextContentLoadingContainer));
